module.exports = __webpack_public_path__ + "static/media/Tupe7.a62abab9.webp";